export default {
  PersonalTagType: "Személyes címkék",
  ProjectTagType: "Projekt címkék",
};
